import { AbstractSchema } from '../../common/args';
import { Capability, CapabilityDefinition } from './types';

export function defineCapability<
  Name extends string,
  Schema extends AbstractSchema,
>(definition: CapabilityDefinition<Name, Schema>) {
  return new Capability(definition);
}
